module.exports = __webpack_public_path__ + "img/Villa_Borna_45.f6d2d94d.jpg";